// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1sgyN","item":"PaymentsMobile_item__1wSDw","label":"PaymentsMobile_label__3h02u","amount":"PaymentsMobile_amount__3M9h8"};